
import React from 'react';
import { slide as Menu } from 'react-burger-menu';
// import Login from '../LoginPage';
import './navbar.css';

export default props => {
  return (
    <Menu>
      <a className="menu-item" href="/omCrPortal/app/home">
        Home
      </a>
      <a className="menu-item" href="/omCrPortal/app/cl">
        CL
      </a>
      <a className="menu-item" href="/omCrPortal/app/MathLabel">
        Math Label 
      </a>
      <a className="menu-item" href="/omCrPortal/app/EnlishLabel">
        English Label
      </a>
      <a className="menu-item" href="/omCrPortal/app/studyPlan">
        Study Plan
      </a>
      <a className="menu-item" href="/omCrPortal/app/AO">
        AO Label Change
      </a>
      <a className="menu-item" href="/omCrPortal/app/AbsentRMs">
          Absent CR's
      </a>
      <a className="menu-item" href="/omCrPortal/app/DailySheet">
          Maths morning response list
      </a>
      <a className="menu-item" href="/omCrPortal/app/MathEveningDailySheet">
          Maths evening response list
      </a>
      <a className="menu-item" href="/omCrPortal/app/EnglishMorningDailySheet">
          English morning response list
      </a>
      <a className="menu-item" href="/omCrPortal/app/EnglishEveningDailySheet">
          English evening response list
      </a>
    </Menu>
  );
};